import React from "react";

import Layout1 from "../layouts/Layout1";
import Layout2 from "../layouts/Layout2";
import Layout3 from "../layouts/Layout3";
import Layout9 from "../layouts/Layout9";
import Layout10 from "../layouts/Layout10";
import Layout13 from "../layouts/Layout13";
import Layout14 from "../layouts/Layout14";
import Layout15 from "../layouts/Layout15";
import Layout16 from "../layouts/Layout16";
import Layout18 from "../layouts/Layout18";
import Layout19 from "../layouts/Layout19";
import Layout20 from "../layouts/Layout20";
import Layout21 from "../layouts/Layout21";
import GrammarSectionLayout from "../layouts/GrammarSectionLayout";

interface Props {
  sectionName: string;
  questions: any[];
}

const layoutMap: Record<
  string,
  Record<string | number, React.ComponentType<any>>
> = {
  Phonics: {
    default: Layout1,
  },

  Syllabification: {
    1: Layout1,
    9: Layout9,
    18: Layout18,
    default: Layout1,
  },

  Blends: {
    default: Layout2,
  },

  HFW: {
    default: Layout16,
  },

  Dictionary: {
    default: Layout3,
  },

  "Read & Comprehend": {
    11: GrammarSectionLayout,
    21: Layout21,
    default: Layout9,
  },
  "Reading and Comprehension": {
    11: GrammarSectionLayout,
    21: Layout21,
    default: Layout9,
  },
  "Reading & Comprehension": {
    11: GrammarSectionLayout,
    21: Layout21,
    default: Layout9,
  },

  Grammar: {
    21: Layout21,
    default: GrammarSectionLayout,
  },

  "Think & Choose": {
    13: Layout13,
    19: Layout19,
    default: Layout13,
  },

  Crossword: {
    default: Layout10,
  },

  "Guess who/what am I": {
    default: Layout14,
  },

  "How many can you think of": {
    default: Layout15,
  },

  Pictionary: {
    default: GrammarSectionLayout,
  },

  "Misspelt Words": {
    default: GrammarSectionLayout,
  },

  "Spot The Intruder": {
    default: GrammarSectionLayout,
  },

  "Antonym Challenge": {
    default: GrammarSectionLayout,
  },

  "Vocabulary Exercise": {
    default: GrammarSectionLayout,
  },

  "Book Review": {
    default: Layout9,
  },

  "Spot the injustice": {
    default: Layout9,
  },

  "Understanding cause and effect": {
    default: Layout9,
  },

  "World of Professions": {
    default: Layout9,
  },

  "Career options": {
    default: Layout9,
  },

  "Picture Decoding": {
    default: GrammarSectionLayout,
  },
};

const LayoutRenderer: React.FC<Props> = ({ sectionName, questions }) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  const uiType = questions[0]?.uiType;

  // Direct UI Type override for Layout21 (Story Ordering Drag & Drop)
  if (uiType === 21) {
    return <Layout21 Questions={questions} sectionName={sectionName} />;
  }

  const normalizedSectionName =
    Object.keys(layoutMap).find(
      (key) => key.toLowerCase() === sectionName.toLowerCase()
    ) || sectionName;

  const sectionLayouts = layoutMap[normalizedSectionName] || {
    default: GrammarSectionLayout,
  };

  const LayoutComponent = sectionLayouts[uiType] || sectionLayouts.default;

  return <LayoutComponent Questions={questions} sectionName={sectionName} />;
};

export default LayoutRenderer;
